const MellonWebECRPayment = require('@/lib/PaymentMethods/MellonWebECR/MellonWebECRPayment');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
const { hydrate } = require('@/lib/Hydration');
const { toFloat, toString } = require('@/functions/transform');

/**
 * An object representing an integrated transaction in progress.
 */
class TransactionInProgress {
    /**
     * @param {string} paymentMethodRef
     * @param {string} [txnRef]
     * @param {number} [amount]
     * @param {object} [state]
     */
    constructor(
        paymentMethodRef,
        txnRef,
        amount,
        state
    ) {
        /**
         * The payment method of the transaction.
         *
         * @type {string}
         */
        this.paymentMethodRef = paymentMethodRef;

        /**
         * A reference for the transaction.
         * What this specifically means will depend on the payment method, but it is usually (if not always?)
         * the thirdParyID of the payment.
         *
         * @type {string}
         */
        this.txnRef = txnRef;

        /**
         * The amount of the transaction.
         *
         * @type {number}
         */
        this.amount = amount;

        /**
         * Arbitrary data about the transaction. The contents will vary depending on the payment method.
         *
         * @type {object}
         */
        this.state = state || {};
    }

    getHydrationMap() {
        return {
            amount: toFloat,
            paymentMethodRef: toString,
            state: {},
            txnRef: {},
        };
    }

    afterHydration() {
        // Do some specific hydration of what could be in the state depending on the payment method.
        if (this.paymentMethodRef === PaymentMethodRef.CARD_MELLON_WEBECR) {
            if (this.state.payment) {
                this.state.payment = hydrate(this.state.payment, new MellonWebECRPayment());
            }
        }
    }

    /**
     * Sets a key-value pair in the `state` object.
     *
     * @param {string} key - The key to set in the data object.
     * @param {*} value - The value to store.
     */
    setValue(key, value) {
        this.state[key] = value;
    }

    /**
     * Retrieves a value from the `state` object.
     *
     * @param {string} key - The key to retrieve.
     * @returns {*} The value associated with the key, or undefined.
     */
    getValue(key) {
        return this.state[key];
    }
}

module.exports = TransactionInProgress;
